/* Scale Code i18n — language toggle + browser detection + localStorage */
(function(){
  'use strict';

  var STR = {
    en: {},  // English is the source — defaults from Liquid stay
    nl: {
      /* Header nav — Jip-en-Janneke style */
      'nav.system': 'Systeem',
      'nav.industries': 'Voor wie',
      'nav.cases': 'Cases',
      'nav.about': 'Over ons',
      'nav.contact': 'Contact',
      'nav.ai': 'Slim met AI',
      'nav.builtForYou': 'Op maat',
      'nav.aiAssessment': 'Gratis AI Scan',
      'nav.bookCall': 'Plan een gesprek',

      /* Language toggle */
      'lang.toggle.aria': 'Taal wisselen',

      /* Hero */
      'hero.headline.line1': 'Where Growth',
      'hero.headline.line2before': 'Gets',
      'hero.headline.roll': 'Engineered.',
      'hero.subtitle': 'Scale Code is er voor de lange termijn. Wij bouwen de groei-infrastructuur die jaar na jaar blijft renderen, en maken die beschikbaar voor pionierende bedrijven die hun markt willen leiden, niet volgen.',
      'hero.cta.primary': 'Plan een gesprek',
      'hero.cta.ghost': 'Toon mij wat jullie doen',

      /* Footer */
      'footer.tagline': 'Jij Bouwt,<br>Wij Schalen.<br>Samen.',
      'footer.description': 'Wij bouwen de complete groei-engine achter ambitieuze bedrijven: creatie, media, systemen, software en AI, als één geheel ontworpen. Marketing die een blijvend bezit wordt, gebouwd om te renderen op de lange termijn.',
      'footer.menu': 'Menu',
      'footer.contact': 'Contact',
      'footer.contactLabel': 'Mail ons',
      'footer.socials': 'Socials',
      'footer.locations': 'Locaties',
      'footer.copyright': 'Alle rechten voorbehouden.',
      'footer.legal': 'Juridisch',
      'footer.legal.howwework': 'Hoe we werken',
      'footer.legal.terms': 'Algemene Voorwaarden',
      'footer.legal.privacy': 'Privacybeleid',
      'footer.legal.cookies': 'Cookiebeleid',
      'footer.legal.agreement': 'Klantovereenkomst',

      /* Positioning — Why Scale Code */
      'pos.tag': 'Waarom Scale Code',
      'pos.titleBefore': 'Wij maken het werk af',
      'pos.titleItalic': 'waar andere bureaus stoppen.',
      'pos.body1': 'Je weet hoe het werkt: een bureau levert klikken, mooie grafieken en likes. Maar geen klanten. Wij komen uit de e-commerce. Daar tellen alleen klanten die kopen.',
      'pos.body2': 'Daarom werken wij als een goedlopend e-commerce merk:',
      'pos.closing': 'Vertrouwd door ambitieuze organisaties.',

      /* VTabs — What We Do */
      'vtabs.tag': 'Wat wij doen',
      'vtabs.titleBefore': 'Alles wat je nodig hebt om',
      'vtabs.titleItalic': 'klanten op schaal binnen te halen.',
      'vtabs.subtitle': 'Vier onderdelen. Eén systeem. Elk onderdeel zorgt voor échte klanten. Niet voor likes.',

      /* Process — How We Work */
      'proc.tag': 'Hoe wij werken',
      'proc.titleBefore': 'Jouw complete',
      'proc.titleItalic': 'groei-systeem.',
      'proc.subtitle': 'Van eerste gesprek tot live ads in weken, niet maanden. Elke stap een check. Niets gaat live zonder jouw goedkeuring.',

      /* Pillars — One agency. Four engines. */
      'pil.eyebrow': 'Eén bureau. Vier motoren.',
      'pil.titleItalic': 'Eén team.',
      'pil.subtitle': 'De meeste bureaus doen één ding. Wij bouwden alle vier onder één dak. Want de beste resultaten komen uit systemen zonder gaten.',
      'pil.connector': 'HET SCALE CODE SYSTEEM',

      /* AI Teaser */
      'ai.badge': 'AI Automatisering',
      'ai.titleBefore': 'Bespaar 10+ uur per week met',
      'ai.titleItalic': 'AI op maat.',
      'ai.subtitle': 'Wij laten AI het saaie werk doen. Jouw team blijft de baas. Alles ingesteld op jouw bedrijf. Geen standaard template. Geen Zapier-stack die ineens stopt.',
      'ai.cta': 'Bekijk alle AI-automatiseringen',

      /* Social Proof */
      'sp.tag': 'Cases',
      'sp.titleBefore': 'Vertrouwd door',
      'sp.titleItalic': 'ambitieuze bedrijven.',
      'sp.subtitle': 'Wij werken met een select aantal klanten tegelijk. Dit zijn de resultaten die we samen bouwen.',
      'sp.casesBtn': 'Bekijk alle cases',

      /* Industries */
      'ind.tag': 'Voor wie',
      'ind.titleBefore': 'De psychologie van kopen',
      'ind.titleItalic': 'is universeel.',
      'ind.subtitle': 'Ons systeem werkt in elke markt. Diensten met hoge tickets, snelle consumentenmerken, B2B SaaS, luxe, gezondheid. De principes blijven. Alleen de hooks veranderen.',

      /* One-off */
      'one.tag': 'Losse diensten',
      'one.titleBefore': 'Nog niet klaar voor het hele systeem?',
      'one.titleItalic': 'Begin met één onderdeel.',

      /* Results */
      'res.tag': 'Resultaten',
      'res.titleBefore': 'Cijfers liegen niet.',
      'res.titleItalic': 'Wij ook niet.',

      /* Founder */
      'fnd.tag': 'De oprichters',
      'fnd.titleBefore': 'Gebouwd door mensen die',
      'fnd.titleItalic': 'het werk zelf doen.',

      /* FAQ */
      'faq.tag': 'FAQ',
      'faq.titleBefore': 'Veelgestelde',
      'faq.titleItalic': 'vragen',
      'faq.subtitle': 'Alles wat je moet weten over werken met ons.',

      /* CTA */
      'cta.tag': 'Laten we praten',
      'cta.titleBefore': 'Klaar om te',
      'cta.titleItalic': 'groeien?',
      'cta.subtitle': 'Plan een gratis gesprek van 30 minuten. Wij kijken naar jouw cijfers en laten zien waar de groei zit.',

      /* Positioning bullets */
      'pos.b1.bold': 'Elke euro wordt gekoppeld aan een echt resultaat.',
      'pos.b1.text': 'Geen klik. Geen like. Een echte lead, een geboekt gesprek, of een verkoop.',
      'pos.b2.bold': 'Elke ad is gebouwd op psychologie, niet op een slogan.',
      'pos.b2.text': 'Wij duiken in de wensen van jouw klant, hun twijfels, en wat ze eerder probeerden, voordat wij ook maar één hook schrijven.',
      'pos.b3.bold': 'Elke lead wordt direct opgevolgd, vanzelf.',
      'pos.b3.text': 'Onze WhatsApp-koppeling stuurt elke lead meteen naar jouw klantsysteem. Geen lead koelt af. Nooit.',
      'pos.b4.bold': 'Alle tools in één systeem.',
      'pos.b4.text': 'Jouw klantsysteem, Meta, WhatsApp, Slack, boekhouding. Andere bureaus plakken Zapier-flows aan elkaar. Wij bouwen het echt in elkaar.',

      /* VTabs cards (4 pillars deep dive) */
      'vtabs.1.title': 'Creative & Content',
      'vtabs.1.desc': 'Ads gebouwd op psychologie, niet op slogans. Wij brengen de wensen, twijfels en ervaringen van jouw klant in kaart, voordat wij iets maken.',
      'vtabs.2.title': 'Paid Advertising',
      'vtabs.2.desc': 'Mediabuying getraind in e-commerce, de strengste markt ter wereld. Werkt de ad niet, dan verlies je geld. Die discipline pakken wij mee.',
      'vtabs.3.title': 'Lead Kwalificatie & Opvolging',
      'vtabs.3.desc': 'Dit maakt Scale Code anders. Elke lead van Meta, TikTok of Google gaat meteen jouw klantsysteem in en wordt direct opgevolgd via WhatsApp.',
      'vtabs.4.title': 'AI Automatisering',
      'vtabs.4.desc': 'Slimme oplossingen voor alles wat jouw team tijd kost. Klantenservice sorteren, offertes opstellen, content hergebruiken. Op maat, geen template.',
      'vtabs.4.btn': 'Bekijk AI Automatiseringen',

      /* Process steps */
      'proc.1.titleBefore': 'Analyseer',
      'proc.1.titleItalic': '& Strategie',
      'proc.1.desc': 'Wij beginnen met jouw hele bedrijf in kaart te brengen. Niet alleen jouw ads. Jouw klanten, concurrenten, werkwijze, cijfers.',
      'proc.2.titleBefore': 'Maak',
      'proc.2.titleItalic': '& Produceer',
      'proc.2.desc': 'Creatieve ads op klantpsychologie. Statics, AI-video, UGC. Plus landingspagina’s, e-mails, en alles wat klanten over de streep trekt.',
      'proc.3.titleBefore': 'Lanceer',
      'proc.3.titleItalic': '& Schaal',
      'proc.3.desc': 'Wij zetten campagnes live op Meta, TikTok en Pinterest. Maar nog belangrijker: wij bouwen het hele systeem dat klanten binnenhaalt.',
      'proc.4.titleBefore': 'Automatiseer',
      'proc.4.titleItalic': '& Sluit de Loop',
      'proc.4.desc': 'Hier wordt het interessant. Elke lead wordt direct opgepakt via onze WhatsApp-koppeling. Naar jouw klantsysteem. Direct opgevolgd.',
      'proc.5.titleBefore': 'Adviseer, Test',
      'proc.5.titleItalic': '& Schaal Op',
      'proc.5.desc': 'Maandelijkse creatives. Funnel-aanpassingen. WhatsApp-flows verfijnen. Plus strategiegesprekken waarin we samen kijken hoe het beter kan.',

      /* Pillars (4) — pillar headings stay English brand language */
      'pil.1.heading': 'Creative Studio',
      'pil.1.desc': 'Ads op psychologie, AI-video, UGC. Gebouwd om te converteren, niet om prijzen te winnen.',
      'pil.2.heading': 'Paid Media',
      'pil.2.desc': 'Volledige campagnes op Meta, TikTok, Pinterest. Elke euro telt mee.',
      'pil.3.heading': 'CRM & Software',
      'pil.3.desc': 'WhatsApp-koppeling, klantsysteem, lead-pijplijnen. De laag die andere bureaus niet hebben.',
      'pil.4.heading': 'AI Division',
      'pil.4.desc': 'Slimme oplossingen die handmatig werk overnemen. Jouw team houdt de regie.',

      /* AI Teaser flow steps */
      'ai.f1.title': 'Input',
      'ai.f1.desc': 'E-mail, formulier, lead, bestelling',
      'ai.f2.title': 'AI verwerkt',
      'ai.f2.desc': 'Sorteren, verrijken, opstellen',
      'ai.f3.title': 'Mens checkt',
      'ai.f3.desc': 'Jouw team keurt goed',
      'ai.f4.title': 'Output',
      'ai.f4.desc': 'Verstuurd, gepost, opgeslagen, klaar',

      /* Social Proof testimonials */
      'sp.1.title': 'Geweldig systeem',
      'sp.1.quote': 'Wij gingen van gokken wat werkt naar een complete creative pijplijn die elke week resultaat levert. Onze ROAS is verdrievoudigd in de eerste maanden.',
      'sp.1.role': 'High-end keukens & interieur',
      'sp.2.title': 'Onze ads compleet veranderd',
      'sp.2.quote': 'Voor Scale Code waren we budget aan het verbranden zonder resultaat. Zij bouwden onze hele funnel opnieuw, maakten scripts en zetten alles in.',
      'sp.2.role': 'Tandartspraktijk · Onderdeel van Lassus',
      'sp.3.title': 'Beste keuze ooit',
      'sp.3.quote': 'De AI-content alleen al was het waard, maar de full-service aanpak maakt het verschil. Strategie, creatie, alles in één hand.',
      'sp.3.role': 'Toonaangevend zonnepanelenbedrijf in de Benelux',
      'sp.4.title': 'Sneller geschaald dan verwacht',
      'sp.4.quote': 'Wij verwachtten geleidelijke groei, maar binnen 60 dagen zaten we op 6x ROAS. Wekelijkse rapporten en constante iteratie.',
      'sp.4.role': 'Boutique sportschool',

      /* Industries (12) */
      'ind.1.name': 'Mode',
      'ind.2.name': 'Supplementen',
      'ind.3.name': 'Huidverzorging',
      'ind.4.name': 'E-commerce',
      'ind.5.name': 'SaaS',
      'ind.6.name': 'Sieraden',
      'ind.7.name': 'Gezondheid & Welzijn',
      'ind.8.name': 'Eten & Drinken',
      'ind.9.name': 'Vastgoed',
      'ind.10.name': 'Coaching',
      'ind.11.name': 'Beauty',
      'ind.12.name': 'Fitness',

      /* One-off categories */
      'one.1.title': 'Branding',
      'one.1.desc': 'De visuele basis die elk serieus bedrijf nodig heeft. Wij bouwen merken die opvallen.',
      'one.2.title': 'Content Productie',
      'one.2.desc': 'Video- en fotoproductie speciaal voor ads en social. Geschoten, geregisseerd, gemonteerd, geleverd.',
      'one.3.title': 'AI Creatie',
      'one.3.desc': 'AI-creatives speciaal voor performance marketing. Snelle iteratie, eindeloze varianten, klaar voor testen.',
      'one.4.title': 'Advies',
      'one.4.desc': 'Losse strategie-sessies voor bedrijven die richting nodig hebben zonder lange contracten. Wij analyseren jouw funnel en geven het vervolg.',

      /* Results (5) — client placeholder names + numbers stay English */
      'res.1.m1Label': 'ROAS',
      'res.1.m2Label': 'Omzetgroei',
      'res.1.desc': 'Geschaald van $12K naar $50K/maand in 90 dagen. Meta Ads creative testing en funnel-optimalisatie.',
      'res.1.tag': 'Meta Ads + Funnels',
      'res.2.m1Label': 'ROAS',
      'res.2.m2Label': 'Maand omzet',
      'res.2.desc': 'AI-creative pipeline en geoptimaliseerde landingspagina’s leverden 6.2x op.',
      'res.2.tag': 'AI + CRO',
      'res.3.m1Label': 'Jaarlijkse omzet',
      'res.3.desc': 'Volledige funnel gebouwd van $0 naar $2.1M in de eerste 12 maanden.',
      'res.3.tag': 'Full Service',
      'res.4.m1Label': 'Kosten omlaag',
      'res.4.m2Label': 'Snelheid omhoog',
      'res.4.desc': 'AI-automatiseringspijplijn vervangt 3 medewerkers. Volledig geautomatiseerd: creatie en rapportage.',
      'res.4.tag': 'AI Automatisering',
      'res.5.m1Label': 'ROAS',
      'res.5.m2Label': 'Omzet',
      'res.5.desc': 'Pinterest + Meta multi-channel strategie. Video-first creatieve aanpak.',
      'res.5.tag': 'Multi-Channel',

      /* Founders (2) — names stay */
      'fnd.1.role': 'Mede-oprichter & CEO',
      'fnd.1.quote': 'Groei-systemen gebouwd door mensen die zowel creatie als code begrijpen.',
      'fnd.2.role': 'Mede-oprichter & CTO',
      'fnd.2.quote': 'Wij doen het tegenovergestelde van wat je eerder verbrand heeft.',

      /* FAQ (7 entries) — tailored to Scale Code audience, no pricing */
      'faq.1.q': 'Hoe lang voordat ik resultaat zie?',
      'faq.1.a': 'De meeste klanten zien beweging in de eerste 30 dagen. Wij lanceren snel, testen veel, en scherpen elke week aan. Het systeem wordt elke maand beter.',
      'faq.2.q': 'Moet ik iets snappen van AI om met jullie te werken?',
      'faq.2.a': 'Nee. Wij gebruiken AI achter de schermen voor het saaie werk. Jij ziet alleen het resultaat: meer leads, snellere opvolging, minder uren aan administratie.',
      'faq.3.q': 'Zit ik vast aan een lange overeenkomst?',
      'faq.3.a': 'Nee. Maand op maand. Onze resultaten houden klanten vast. Niet onze contracten.',
      'faq.4.q': 'Werken jullie met mijn type bedrijf?',
      'faq.4.a': 'Wij werken met service-bedrijven die online klanten binnenhalen: klinieken, salons, tandartspraktijken, zonnepanelen, keukens, sportscholen, e-commerce merken. Het systeem past zich aan jouw branche aan. De principes blijven, alleen de hooks veranderen.',
      'faq.5.q': 'Wat maakt jullie anders dan andere bureaus?',
      'faq.5.a': 'Drie dingen. Eén: wij komen uit e-commerce, waar elke euro moet werken. Die discipline brengen wij overal mee. Twee: wij draaien niet alleen ads, wij bouwen het systeem dat van leads klanten maakt. Drie: elke lead komt vanzelf in WhatsApp en jouw klantsysteem terecht. Geen lead koelt af.',
      'faq.6.q': 'Wat moet mijn team zelf doen?',
      'faq.6.a': 'Ongeveer 30 minuten per week. Creatives goedkeuren, feedback geven over leads, vertellen wat wel en niet werkt. Wij doen de rest. Het hele punt van dit systeem is dat het draait zonder dat jouw team de flessenhals wordt.',
      'faq.7.q': 'Is de WhatsApp-automatisering echt inbegrepen?',
      'faq.7.a': 'Ja. De WhatsApp Business API, de koppeling met jouw klantsysteem, en de automatische kwalificatie zitten standaard in ons systeem. Geen upsell. Geen toevoeging. Het is precies het verschil tussen een campagne en een echte klantfabriek.',

      /* ============================================== */
      /* ===== AI AUTOMATIONS PAGE ==================== */
      /* ============================================== */

      /* Hero (sc-hero on AI page) */
      'ai-automations.hero.subtitle': 'Jouw team doet werk dat AI in seconden kan. Leads sorteren. E-mails triagen. Offertes opstellen. Facturen verwerken. Wij bouwen op maat gemaakte AI-workflows die het saaie werk overnemen.',
      'ai-automations.hero.cta.primary': 'Plan een gratis audit',
      'ai-automations.hero.cta.ghost': 'Doe de AI-scan',

      /* Why now (sc-positioning on AI page) */
      'ai-automations.pos.tag': 'Waarom nu',
      'ai-automations.pos.titleBefore': 'De bedrijven die dit als eerste uitvogelen',
      'ai-automations.pos.titleItalic': 'lopen straks voorop.',
      'ai-automations.pos.body1': 'Elk bedrijf heeft dezelfde 10 tot 20 uur administratief werk per persoon, per week. E-mails sorteren, data invoeren, leads opvolgen, rapporten maken. Werk dat moet, maar niemand vooruit helpt.',
      'ai-automations.pos.body2': 'De bedrijven die nu stilletjes AI-workflows bouwen, zijn straks de bedrijven met slankere teams, snellere uitvoering, en een voorsprong die niet meer in te halen is.',
      'ai-automations.pos.closing': 'De verschuiving is bezig. De vraag is of jij voorop loopt of straks moet bijbenen.',

      /* How we build (sc-process-alt on AI page) */
      'ai-automations.proc.tag': 'Hoe wij werken',
      'ai-automations.proc.titleBefore': 'Van eerste gesprek tot live automatisering',
      'ai-automations.proc.titleItalic': 'in 2 tot 4 weken.',
      'ai-automations.proc.subtitle': 'Geen vage werkomschrijvingen. Geen builds van zes maanden die uit de hand lopen. Een helder proces met checks bij elke stap.',
      'ai-automations.proc.1.titleBefore': 'Scoping',
      'ai-automations.proc.1.titleItalic': 'gesprek.',
      'ai-automations.proc.1.desc': '30 tot 60 minuten. Wij brengen jouw werkwijze in kaart, vinden waar tijd weglekt, en bepalen welke automatisering de meeste impact heeft.',
      'ai-automations.proc.2.titleBefore': 'Proces',
      'ai-automations.proc.2.titleItalic': 'in kaart.',
      'ai-automations.proc.2.desc': 'Wij lopen mee met jouw team. Elke stap. Elke uitzondering. Elk tool. Zo bouwen wij precies wat past.',
      'ai-automations.proc.3.titleBefore': 'Bouw',
      'ai-automations.proc.3.titleItalic': '& test.',
      'ai-automations.proc.3.desc': 'Wij bouwen de automatisering, testen met echte data uit jouw bedrijf, en iteren tot het feilloos werkt.',
      'ai-automations.proc.4.titleBefore': 'Overdracht',
      'ai-automations.proc.4.titleItalic': '& monitoring.',
      'ai-automations.proc.4.desc': 'Volledige documentatie. Training voor jouw team. Plus optionele monitoring waar wij de automatisering blijven bewaken.',

      /* Who-for (sc-who-for on AI page) */
      'ai-automations.whoFor.tag': 'Voor wie',
      'ai-automations.whoFor.titleBefore': 'Herken jij dit in jouw team?',
      'ai-automations.whoFor.titleItalic': 'Dan moeten we praten.',
      'ai-automations.whoFor.1.title': 'Je verzuipt in inkomende leads.',
      'ai-automations.whoFor.1.body': 'Honderden formulieren, WhatsApp-berichten of DMs per maand. De helft wordt nooit opgevolgd.',
      'ai-automations.whoFor.2.title': 'Jouw team verspilt uren aan herhalend werk.',
      'ai-automations.whoFor.2.body': 'Facturen, data invoeren, e-mails sorteren, offertes opstellen. Werk dat moet, maar niemand vooruit helpt.',
      'ai-automations.whoFor.3.title': 'Jouw tools praten niet met elkaar.',
      'ai-automations.whoFor.3.body': 'CRM, ad-platformen, boekhouding, e-mail, Slack. Allemaal apart. Informatie wordt heen en weer gekopieerd.',
      'ai-automations.whoFor.4.title': 'Je wilt opschalen zonder meer mensen aan te nemen.',
      'ai-automations.whoFor.4.body': 'Je zit op het punt waar de volgende groeistap drie nieuwe collega’s vraagt. Of één slimme automatisering.',

      /* FAQ on AI page (sc-faq) */
      'ai-automations.faq.titleBefore': 'Veelgestelde',
      'ai-automations.faq.titleItalic': 'vragen',
      'ai-automations.faq.subtitle': 'Alles wat je wilde weten over AI-automatisering op maat.',
      'ai-automations.faq.1.q': 'Hoe is dit anders dan no-code tools zoals Zapier of Make?',
      'ai-automations.faq.1.a': 'No-code tools werken prima voor simpele A-naar-B taken. Wij bouwen automatiseringen die zelf beslissingen nemen, koppelen met systemen die geen API hebben, en uitzonderingen aankunnen.',
      'ai-automations.faq.2.q': 'Verliezen wij controle als AI het werk doet?',
      'ai-automations.faq.2.a': 'Nee. Elke automatisering die wij bouwen heeft check-momenten waar jouw team beoordeelt en goedkeurt. AI doet het voorwerk. Jouw team houdt de regie.',
      'ai-automations.faq.3.q': 'Hoe lang duurt het om een automatisering te bouwen?',
      'ai-automations.faq.3.a': 'De meeste automatiseringen draaien live binnen 2 tot 4 weken. Wij beginnen met een scoping-gesprek, brengen jouw werkwijze in kaart, en bouwen iteratief.',
      'ai-automations.faq.4.q': 'Met welke tools kunnen jullie koppelen?',
      'ai-automations.faq.4.a': '100+ platformen: Gmail, Outlook, Slack, Notion, Airtable, Salesforce, HubSpot, Pipedrive, Shopify, en alles wat een API heeft.',
      'ai-automations.faq.5.q': 'Wat als de AI een fout maakt?',
      'ai-automations.faq.5.a': 'Daarom bestaan de check-momenten. AI bedenkt en beslist, jouw team keurt goed. Plus wij bouwen alarmen in zodat afwijkingen direct opvallen.',
      'ai-automations.faq.6.q': 'Wat moet ik investeren?',
      'ai-automations.faq.6.a': 'Elke automatisering wordt apart bekeken. Wij beginnen met een gratis audit waarin wij precies in kaart brengen wat een automatisering jou oplevert, voordat er ook maar één euro op tafel ligt.',

      /* CTA on AI page (sc-cta) */
      'ai-automations.cta.tag': 'Laten we bouwen',
      'ai-automations.cta.titleBefore': 'Klaar om jouw bedrijf',
      'ai-automations.cta.titleItalic': 'te automatiseren?',
      'ai-automations.cta.subtitle': 'Plan een gratis audit van 30 minuten. Wij brengen jouw werkwijze in kaart en laten precies zien wat AI kan overnemen. Geen pitch, alleen inzicht.',

      /* ============================================== */
      /* ===== ABOUT PAGE ============================ */
      /* ============================================== */

      /* Hero on About */
      'about.hero.subtitle': 'Wij begonnen Scale Code omdat echte bedrijven een groei-partner verdienen die echt presteert. Niet weer een bureau dat dromen verkoopt.',
      'about.hero.cta.primary': 'Plan een gesprek',
      'about.hero.cta.ghost': 'Ons verhaal',

      /* Founders on About (different blocks than homepage) */
      'about.fnd.tag': 'De oprichters',
      'about.fnd.titleBefore': 'Gebouwd door mensen die',
      'about.fnd.titleItalic': 'het werk zelf doen.',
      'about.fnd.1.role': 'Mede-oprichter & CEO',
      'about.fnd.1.quote': 'Ik bouwde Scale Code omdat ik moe werd van bureaus die dromen verkopen en spreadsheets leveren.',
      'about.fnd.2.role': 'Mede-oprichter & CTO',
      'about.fnd.2.quote': 'De beste groei-systemen worden gebouwd door mensen die zowel marketing als code begrijpen.',

      /* CTA on About */
      'about.cta.tag': 'Laten we praten',
      'about.cta.titleBefore': 'Klaar om het team',
      'about.cta.titleItalic': 'te ontmoeten?',
      'about.cta.subtitle': 'Plan een gratis gesprek van 30 minuten. Wij laten zien hoe wij jouw groei zouden aanpakken.',

      /* About page — Story (sc-about-story) */
      'about.story.tag': 'Ons verhaal',
      'about.story.titleBefore': 'Hoe het',
      'about.story.titleItalic': 'begon.',
      'about.story.body': '<p>Wij keken toe hoe merk na merk geld stak in bureaus die de wereld beloofden. Mooie decks, grote budgetten, indrukwekkende vakjargon. En middelmatige resultaten zonder verantwoording. Sylvester zag het vanuit de mediabuying: campagnes op gokwerk, creatives die hun doel misten, teams die verdwenen zodra het contract getekend was. Christophe zag het vanuit de tech- en e-commerce-kant: rommelige systemen, losse tools, groei-strategieën bij elkaar gehouden met plakband.</p><p>Maar wij hadden ook gezien hoe het wél kan. In de e-commerce. In de loopgraven waar elke euro moest werken en waar je nergens kon wegduiken. Die wereld leerde ons drie dingen die bureaus daarbuiten bijna nooit leren. Elke cent moet kloppen. Elke ad moet verkopen. En elke lead moet binnen seconden opgevolgd worden, anders is hij weg.</p><p>Dus wij stelden onszelf een vraag. Wat als een bureau werkt als een goedlopend e-commerce merk? Eentje dat de creatives bouwt, de ads draait, de automatiseringen ontwikkelt, en de hele funnel van begin tot eind in handen heeft. Onder één dak. Met één team. Geen onderaannemers. Geen gaten.</p><p>Wij begonnen vanuit Amsterdam, met een kleine groep merken die genoeg hadden van het rondgeschuif. Binnen maanden spraken de cijfers. Lagere CPA\'s. Hogere ROAS. En klanten die eindelijk het gevoel hadden dat iemand net zo hard in hun groei investeerde als zijzelf. Vandaag werken wij voor modemerken, supplementen, klinieken, SaaS-bedrijven en e-commerce merken in heel Europa. En de missie is niet veranderd. Beter bouwen. Sneller bewegen. Echte groei leveren.</p>',

      /* About page — Team (sc-team) */
      'about.team.tag': 'Het team',
      'about.team.titleBefore': 'De mensen achter',
      'about.team.titleItalic': 'de resultaten.',
      'about.team.1.role': 'CEO & Mede-oprichter',
      'about.team.1.bio': 'Stuurt het team aan, stroomlijnt de werkwijze en bepaalt de strategie.',
      'about.team.2.role': 'CTO & Mede-oprichter',
      'about.team.2.bio': 'Bouwt de automatiseringen die output vermenigvuldigen en opschalen mogelijk maken.',
      'about.team.3.role': 'Lead Editor',
      'about.team.3.bio': 'Maakt van brand-verhalen visuals die je niet voorbij scrolt.',
      'about.team.4.role': 'DOP & Immersive Design',
      'about.team.4.bio': 'Brengt artistieke visie tot leven en zet creatieve strategie om in beeld.',
      'about.team.5.role': 'Camera-assistent',
      'about.team.5.bio': 'Ondersteunt het team op de set en zorgt dat de productie loopt.',
      'about.team.6.role': 'Editor',
      'about.team.6.bio': 'Maakt van ruwe content materiaal waar mensen op blijven hangen.',

      /* About page — Values (sc-values) */
      'about.values.tag': 'Onze waarden',
      'about.values.titleBefore': 'Waar wij',
      'about.values.titleItalic': 'voor staan.',
      'about.values.1.title': 'Eigenaarschap, niet uitbesteden',
      'about.values.1.desc': 'Wij besteden niets uit. Elke ad, elke campagne, elk systeem wordt door ons team gebouwd.',
      'about.values.2.title': 'Resultaten, geen rapporten',
      'about.values.2.desc': 'Wij meten succes aan jouw groei, niet aan hoe mooi het dashboard eruitziet.',
      'about.values.3.title': 'Transparantie, geen mysterie',
      'about.values.3.desc': 'Jij weet altijd wat wij doen, waarom, en wat het kost. Geen verborgen kosten. Geen black boxes.',
      'about.values.4.title': 'Snelheid boven perfectie',
      'about.values.4.desc': 'Wij lanceren snel, testen snel, leren snel. Perfectie is de vijand van winstgevende groei.',
      'about.values.5.title': 'Psychologie boven slogans',
      'about.values.5.desc': 'Wij bouwen ads op wat jouw klant écht wil. Niet op wat goed klinkt in een brand deck.',
      'about.values.6.title': 'Systemen, geen losse projecten',
      'about.values.6.desc': 'Wij bouwen motoren die zich opstapelen. Niet campagnes die pieken en doodbloeden.',

      /* CTA form fields (used on every page that renders sc-cta) */
      'cta.formHeadline': 'Neem contact op',
      'cta.form.name': 'Jouw naam',
      'cta.form.email': 'Jouw e-mail',
      'cta.form.industry': 'Jouw branche / type bedrijf',
      'cta.form.body': 'Vertel ons over jouw situatie en hoe wij kunnen helpen…',
      'cta.form.submit': 'Verstuur bericht',
      'cta.form.getintouch': 'Neem contact op',
      'cta.check.1': 'Geen verplichting',
      'cta.check.2': 'Gratis ad-account audit',
      'cta.check.3': 'Groei-roadmap op maat',
      /* AI-page CTA (same form, page-prefixed) */
      'ai-automations.cta.formHeadline': 'Neem contact op',
      'ai-automations.cta.form.name': 'Jouw naam',
      'ai-automations.cta.form.email': 'Jouw e-mail',
      'ai-automations.cta.form.industry': 'Jouw branche / type bedrijf',
      'ai-automations.cta.form.body': 'Vertel ons over jouw situatie en hoe wij kunnen helpen…',
      'ai-automations.cta.form.submit': 'Verstuur bericht',
      'ai-automations.cta.form.getintouch': 'Neem contact op',
      'ai-automations.cta.check.1': 'Geen verplichting',
      'ai-automations.cta.check.2': 'Gratis ad-account audit',
      'ai-automations.cta.check.3': 'Groei-roadmap op maat',
      /* About-page CTA */
      'about.cta.formHeadline': 'Neem contact op',
      'about.cta.form.name': 'Jouw naam',
      'about.cta.form.email': 'Jouw e-mail',
      'about.cta.form.industry': 'Jouw branche / type bedrijf',
      'about.cta.form.body': 'Vertel ons over jouw situatie en hoe wij kunnen helpen…',
      'about.cta.form.submit': 'Verstuur bericht',
      'about.cta.form.getintouch': 'Neem contact op',
      'about.cta.check.1': 'Geen verplichting',
      'about.cta.check.2': 'Gratis ad-account audit',
      'about.cta.check.3': 'Groei-roadmap op maat',

      /* Cases page */
      'cases.eyebrow': 'Klantresultaten',
      'cases.h1Before': 'Groei die verder gaat dan ze',
      'cases.h1Italic': 'voor mogelijk hielden.',
      'cases.subtitle': 'Een kijkje achter de groei die we voor onze klanten bouwen: creatie, ads, opvolging, software en AI als één geheel.',
      'cases.1.industry': 'Premium keukens & interieur',
      'cases.2.industry': 'Tandartspraktijk',
      'cases.3.industry': 'Medische kliniek',
      'cases.4.industry': 'Zonnepanelen',
      'cases.5.industry': 'Keukens',
      'cases.6.industry': 'Boutique sportschool',
      'cases.7.industry': 'Software',
      'cases.results.kicker': 'Echte resultaten, echte groei',
      'cases.results.headingBefore': 'Echte groei, gebouwd voor',
      'cases.results.headingItalic': 'echte bedrijven.',
      'cases.results.subtitle': 'Begin met de basis. Voeg logo’s, screenshots en echte cijfers toe zodra de bewijslijst groeit.',
      'cases.proof.title': 'Scale Code Case Resultaat',
      'cases.result.screenshot': 'Resultaat screenshot',
      'cases.result.1.label': 'Casestudy #1',
      'cases.result.2.label': 'Casestudy #2',
      'cases.result.3.label': 'Casestudy #3',
      'cases.result.4.label': 'Casestudy #4',
      'cases.result.5.label': 'Casestudy #5',
      'cases.result.6.label': 'Casestudy #6',
      'cases.result.2.headline': '',
      'cases.result.data.adBudget': 'Advertentiebudget',
      'cases.result.data.cpl': 'Kosten per lead',
      'cases.result.data.conversions': 'Conversies',
      'cases.result.data.revenue': 'Totale omzet',
      'cases.result.systems.label': 'Ingebouwd',
      'cases.result.system.content': 'content',
      'cases.result.system.paidAds': 'ads',
      'cases.result.system.autoFollowUp': 'automatische opvolging',
      'cases.result.system.appointmentSetter': 'afspraak-bot',
      'cases.result.link.website': 'website',
      'cases.result.link.instagram': 'Instagram',
      'cases.result.before.title': 'Voor',
      'cases.result.after.title': 'Na',
      'cases.result.1.before': 'Ze begonnen vanaf nul: geen ads, geen funnel, geen fundament.',
      'cases.result.1.after': 'Wij legden het complete marketingfundament van de grond af en schaalden het naar ~€1,4M in 10 maanden.',
      'cases.result.2.before': 'Patiëntleads kwamen binnen via losse campagnes, zonder duidelijk zicht op afspraakwaarde.',
      'cases.result.2.after': '32 nieuwe patiënten uit 443 Meta-leads, goed voor €64k-€128k geschatte patiëntwaarde.',
      'cases.result.3.before': 'Leadgeneratie en offerteaanvragen waren nog niet gekoppeld aan duidelijke waardetracking.',
      'cases.result.3.after': 'Advertentiebudget, leads en offertewaarde zijn nu zichtbaar in één duidelijke groeilus.',
      'cases.result.4.before': 'Behandelaanvragen moesten sneller worden gekwalificeerd en opgevolgd.',
      'cases.result.4.after': 'Leads gaan nu via content, ads en automatische opvolging door een flow.',
      'cases.result.5.before': 'Handmatige opvolging vertraagde nieuwe patiëntaanvragen.',
      'cases.result.5.after': 'Leads worden nu beantwoord, gekwalificeerd en doorgestuurd via WhatsApp en CRM.',
      'cases.result.6.before': 'Groei hing af van losse contentmomenten zonder duidelijke ads-structuur.',
      'cases.result.6.after': 'Content en ads sluiten nu aan op een duidelijkere groeilus.',
      'cases.slotervaart.proof.eyebrow': 'Grote impact',
      'cases.slotervaart.proof.pipelineRoas': 'pipeline ROAS',
      'cases.slotervaart.proof.pipelineNote': 'Gebaseerd op €35.200 verwachte pipelinewaarde vs. €2.877,78 advertentiebudget',
      'cases.slotervaart.proof.adSpend': 'advertentiebudget',
      'cases.slotervaart.proof.firstIntakePipeline': 'eerste intake pipelinewaarde',
      'cases.slotervaart.proof.patientValue': 'patiëntwaarde gegenereerd',
      'cases.slotervaart.proof.ltvNote': 'Gebaseerd op afgeronde patiënten en geschatte patiëntwaarde',
      'cases.slotervaart.proof.ltvRoas': 'LTV ROAS',
      'cases.slotervaart.proof.totalIntake': 'totale intakekansen',
      'cases.slotervaart.proof.leads': 'leads',
      'cases.slotervaart.proof.costPerLead': 'kosten per lead',
      'cases.slotervaart.proof.bookedHandled': 'geboekte of opgevolgde intakes',
      'cases.slotervaart.proof.waitingList': 'mensen op de wachtlijst',
      'cases.slotervaart.proof.consultsAuto': 'consults automatisch geboekt',
      'cases.slotervaart.proof.projectedPipeline': 'verwachte pipelinewaarde',
      'cases.cta.heading': 'Klaar om met ons te bouwen?',
      'cases.cta.btn1': 'Doe de gratis scan',
      'cases.cta.btn2': 'Plan een gesprek',
      'home.stat1.label': 'Omzet voor klanten',
      'home.stat2.label': 'Maandelijks beheerd advertentiebudget',
      'home.stat3.label': 'Slagingspercentage klanten',
      'home.stat4.label': 'Gemiddeld rendement op investering',
      'home.logos.label': 'Beoordeeld met 5/5 door onze klanten',
      'cases.result.system.salesTraining': 'sales-training',
      'cases-live.ctaband.titleItalic': 'Neem contact op.',
      'cases.heroStat1': 'Omzet voor klanten in de afgelopen 12 maanden',
      'cases.heroStat2': 'Maandelijks beheerd advertentiebudget',
      'cases.heroStat3': 'Slagingspercentage klanten',
      'cases.heroStat4': 'Gemiddeld rendement op investering',
      'cases-live.systems.s5.title': 'Sites & Dashboards op maat',
      'cases-live.systems.s5.statement': 'Vanaf nul gebouwd, volledig op jou afgestemd.',
      'cases-live.systems.s5.line1': 'Custom landingspagina’s en volledige websites',
      'cases-live.systems.s5.line2': 'Dashboards rond jouw cijfers en team',
      'cases-live.systems.s5.line3': 'Geen templates, gebouwd zoals jij werkt',
      'cases-live.systems.s6.title': 'Sales-training & consults',
      'cases-live.systems.s6.statement': 'Je hele team naar een hoger niveau, inbegrepen.',
      'cases-live.systems.s6.line1': 'Hands-on sales-training voor het hele team',
      'cases-live.systems.s6.line2': 'Doorlopende strategie-consults terwijl je opschaalt',
      'cases-live.systems.s6.line3': 'Onderdeel van elke samenwerking, geen meerprijs',

      /* --- CTA band (sc-cta-band) 2026-06-12 --- */
      'cases-live.ctaband.eyebrow': 'Wanneer jij wil',
      'cases-live.ctaband.title': 'Zien hoe we jou kunnen helpen groeien?',
      'cases-live.ctaband.subtitle': 'Plan een gesprek en we laten zien hoe we jouw groei aanpakken. Geen pitch, gewoon een plan.',
      'cases-live.scta.rating': 'Beoordeeld met 5/5 door onze klanten',
      'cases-live.scta.title': 'Start vandaag met schalen',
      'cases-live.scta.text': 'Jaren aan bewezen strategieën en een tomeloze inzet voor jouw groei. Laten we samen iets bijzonders bouwen. Start vandaag met schalen en vraag een gratis ad account audit aan.',
      'cases-live.scta.btn': 'Gratis Ad Account Audit',
      'cases-live.scta.spots': 'Nog 3 plekken beschikbaar deze maand',
      'cases-live.scta.partners': 'Officiële partner',
      'cases-live.ctaband.btn1': 'Plan een gesprek',
      'cases-live.ctaband.btn2': 'Doe de gratis scan',

      /* --- Editorial slider (sc-case-details) 2026-06-12 --- */
      'cases-live.cd.eyebrow': 'Gebouwd voor klanten',
      'cases-live.cd.title': 'Van dichtbij bekeken.',
      'cases-live.cd.subtitle': 'Swipe door wat we per klant bouwden en de cijfers die het draait.',
      'cases-live.casesfaq.eyebrow': 'FAQ',
      'cases-live.casesfaq.titleBefore': 'Veelgestelde',
      'cases-live.casesfaq.titleItalic': 'Vragen.',
      'cases-live.casesfaq.1.q': "Wat maakt Scale Code anders dan andere bureaus?",
      'cases-live.casesfaq.1.a': "De meeste bureaus doen één ding. Wij zijn eigenlijk drie bureaus in één, onder één dak en één strategie: een creatie- en videostudio, een team voor paid media en media buying, en een team voor CRM, automatisering en AI-ontwikkeling. We draaien dus niet alleen je ads, we bouwen de creatives die ze laten werken, de systemen die elke lead vastleggen en de opvolging die automatisch gebeurt. Een complete marketingtransformatie, geen losse dienst.",
      'cases-live.casesfaq.2.q': "Met wat voor bedrijven werken jullie?",
      'cases-live.casesfaq.2.a': "Ambitieuze high-margin bedrijven die klaar zijn om te schalen, van gevestigde merken en klinieken tot groepen met meerdere vestigingen, e-commerce en B2B. We richten ons op bedrijven met sterke marges en echte ruimte om te groeien. De principes blijven gelijk over markten en grenzen heen, alleen de strategie rond jouw aanbod en doelen verandert.",
      'cases-live.casesfaq.3.q': "Wat zijn jullie prijsopties?",
      'cases-live.casesfaq.3.a': "Dat hangt af van de scope. De meeste klanten werken met ons op een maandelijkse retainer die de onderdelen dekt die ze nodig hebben: creatie en content, media buying, en de CRM-, automatiserings- en AI-bouw. Sommige trajecten zijn projectmatig. We leggen scope en kosten schriftelijk vast voordat we beginnen, zonder verborgen kosten. Advertentiebudget staat los en gaat rechtstreeks naar de platforms.",
      'cases-live.casesfaq.4.q': "Hoe lang duurt het voordat ik resultaat zie?",
      'cases-live.casesfaq.4.a': "De basis, creatives, tracking en systemen, bouwen we in de eerste weken, niet maanden. Eerste signalen uit campagnes komen vaak binnen enkele weken, en echte, opbouwende resultaten groeien daarna naarmate we testen en opschalen. We zijn vanaf dag één eerlijk over de tijdlijnen, en we bouwen groei die blijft in plaats van pieken van één nacht.",
      'cases-live.casesfaq.5.q': "Wie maakt de creatieve content?",
      'cases-live.casesfaq.5.a': "Dat doen wij, en dat onderscheidt ons. Je kunt je eigen materiaal aanleveren, maar met ons werken betekent dat we hands-on zijn: we ontwerpen en testen statische ad-creatives voor jouw bedrijf, en we maken videografie en short-form video van hoog niveau in eigen huis. Creatie bepaalt of een campagne wint of verliest, dus het is bij ons een kerndienst, geen bijzaak.",
      'cases-live.casesfaq.6.q': "Wat kan ik verwachten van het kennismakingsgesprek?",
      'cases-live.casesfaq.6.a': "Een gericht gesprek over jouw bedrijf, je cijfers en je doelen, geen verkooppraatje. Je gaat weg met een helder beeld van waar de groei zit en hoe wij het zouden aanpakken over creatie, media en systemen. Klikt het, dan gaan we door; zo niet, dan heb je alsnog een plan.",
      'cases-live.casesfaq.7.q': "Heb ik een groot advertentiebudget nodig?",
      'cases-live.casesfaq.7.a': "Nee. Belangrijker dan de grootte van het budget is een sterk aanbod en ruimte om te testen en op te schalen. We zijn eerlijk over wat je budget realistisch kan opleveren, en we bouwen de creatie en systemen zodat elke euro harder werkt. Naarmate resultaten zich bewijzen, schalen we het budget bewust op, op basis van de data.",
      'cases-live.casesfaq.8.q': "Welke resultaten kan ik verwachten?",
      'cases-live.casesfaq.8.a': "Dat hangt af van je markt, aanbod en budget, dus we beloven geen exacte cijfers. Wat we wél beloven is een complete groei-engine, betere creatives, scherper media buying en automatisering die elke lead vastlegt en opvolgt, met volledige transparantie over wat werkt. Het doel is echte, opbouwende groei die je terugziet in je cijfers.",
      'cases-live.casesfaq.9.q': "Hoe zorgen jullie voor transparantie en vertrouwen?",
      'cases-live.casesfaq.9.a': "Jij bent eigenaar van je accounts, data en systemen, en je hebt altijd toegang. Je krijgt heldere wekelijkse performance-recaps, maandelijkse strategische reviews en live dashboards zodat je je cijfers kunt bekijken wanneer je wilt. Elke beslissing en test wordt vastgelegd. Geen black box, geen gegijzelde data.",
      'cases-live.casesfaq.10.q': "Wat als ik slechte ervaringen heb met andere bureaus?",
      'cases-live.casesfaq.10.a': "Je bent niet de enige, het is mede waarom we Scale Code zo hebben opgebouwd. Slechte ervaringen komen meestal van bureaus die één ding doen, te veel beloven en zich verschuilen achter ijdele cijfers. Wij brengen creatie, media en systemen onder één dak, blijven hands-on en rapporteren over wat echt telt. We verdienen je vertrouwen liever met resultaten dan met mooie praatjes.",
      'cases-live.cd.c1.headline': 'Acquisitie vanaf nul opgebouwd',
      'cases-live.cd.c1.impact': 'Volledige paid-, creatie- en CRM-funnel vanaf nul gebouwd, levert nu wekelijks gekwalificeerde aanvragen.',
      'cases-live.cd.c2.headline': 'Patiëntenmotor voor de tandarts',
      'cases-live.cd.c2.impact': 'AI-setter en CRM regelen de patiënt-intake end-to-end, van eerste bericht tot ingeplande afspraak.',
      'cases-live.cd.c3.headline': '24/7 patiënten kwalificeren',
      'cases-live.cd.c3.impact': 'Eigen AI WhatsApp-agent kwalificeert en routeert elke patiëntlead dag en nacht, gekoppeld aan de CRM.',
      'cases-live.cd.c4.headline': 'Leadgeneratie voor zonnepanelen',
      'cases-live.cd.c4.impact': 'Meta-leadgeneratie, CRM-tagging en WhatsApp-opvolging als één offerte-naar-deal-lus.',
      'cases-live.cd.c5.headline': 'Showroombezoek op afroep',
      'cases-live.cd.c5.impact': 'Aanbod-gedreven campagnes en automatische kwalificatie sturen alleen serieuze kopers naar de showroom.',
      'cases-live.cd.c6.headline': 'Ledenwerf-motor',
      'cases-live.cd.c6.impact': 'Content, paid en een WhatsApp-funnel houden de agenda vol met proeflessen op de automatische piloot.',
      'cases-live.cd.c7.headline': 'Voorraadsoftware op maat',
      'cases-live.cd.c7.impact': 'Eigen voorraadsysteem met Discord-updates en automatische dagrapportage. Geen spreadsheets meer.',
      'cases-live.cd.c8.headline': 'Onze eigen groei-stack',
      'cases-live.cd.c8.impact': 'Eigen site naar CRM naar agenda naar Google Meet, volledig geautomatiseerd, plus een AI-scan van 9 vragen.',

      /* --- New cases-page sections (2026-06-12): systems grid, mission, process --- */
      'cases-live.systems.cta': 'Doe de gratis scan',
      'cases-live.systems.eyebrow': 'Wat we bouwen',
      'cases-live.systems.s1.line1': 'Gebouwd op de echte pijnpunten en bezwaren van je klant',
      'cases-live.systems.s1.line2': 'Uitgeschreven tot scroll-stoppende video- en static-creatives',
      'cases-live.systems.s1.line3': 'De brandstof waar al je ads op draaien',
      'cases-live.systems.s1.statement': 'Klantpijn omgezet in advertentiemateriaal.',
      'cases-live.systems.s1.title': 'Contentmotor',
      'cases-live.systems.s2.line1': 'Meta- en Google-ads-systeem met ingebouwde leadkwalificatie',
      'cases-live.systems.s2.line2': 'Hoge leadkwaliteit, lage kost per lead',
      'cases-live.systems.s2.line3': 'Automatische WhatsApp-opvolging zodra een lead binnenkomt',
      'cases-live.systems.s2.statement': 'High-intent leads tegen een lage kost per lead.',
      'cases-live.systems.s2.title': 'Schaalbaar Ad-systeem',
      'cases-live.systems.s3.line1': 'Volledig pipeline-overzicht voor iedereen',
      'cases-live.systems.s3.line2': 'Ingebouwde belfunctie met gespreksopname',
      'cases-live.systems.s3.line3': 'Opnames en rapporten voor sales-training',
      'cases-live.systems.s3.statement': 'Eén plek waar het hele team in werkt.',
      'cases-live.systems.s3.title': 'Team-CRM & Pipeline',
      'cases-live.systems.s4.line1': 'Plant automatisch afspraken in',
      'cases-live.systems.s4.line2': 'Neemt het eerste contact met elke nieuwe lead op',
      'cases-live.systems.s4.line3': 'Geeft je team ruimte om te closen, niet na te jagen',
      'cases-live.systems.s4.statement': 'Plant afspraken in en werkt elke lead op.',
      'cases-live.systems.s4.title': 'AI Conversational Agent',
      'cases-live.systems.subtitle': 'Alles wat we zelf bouwen om het werk achter jouw groei draaiende te houden.',
      'cases-live.systems.title': 'De motor achter jouw',
      'cases-live.systems.titleItalic': 'groei.',
      'cases-live.mission.cta': 'Doe de gratis assessment',
      'cases-live.mission.eyebrow': 'Waarom teams voor ons kiezen',
      'cases-live.mission.p1.body': 'We draaien niet alleen je advertenties of versturen je e-mails. We kijken naar je hele bedrijf, van content en creatives tot je site, je funnel en de systemen daarachter.',
      'cases-live.mission.p1.close': 'Waar de meeste bureaus stoppen, gaan wij door.',
      'cases-live.mission.p1.title': 'Wij zijn je groeipartner.',
      'cases-live.mission.p2.body': 'Klanten blijven bij ons voor de resultaten, en voor de manier waarop we werken: korte lijnen, snelle antwoorden en een team dat jouw doelen behandelt als die van zichzelf. Geen uitdaging is te groot en niets is te veel gevraagd.',
      'cases-live.mission.p2.close': 'We gaan voor elke klant, elke keer, dat stapje extra.',
      'cases-live.mission.p2.title': 'Een persoonlijke aanpak, echte communicatie.',
      'cases-live.mission.p3.body': 'Geen twee bedrijven zijn hetzelfde, dus de systemen die we bouwen ook niet. We nemen de tijd om je markt, je koper en je doelen te begrijpen voordat we ook maar iets bouwen.',
      'cases-live.mission.p3.close': 'Strategieën gebouwd voor blijvende, meetbare groei.',
      'cases-live.mission.p3.title': 'Op maat van jouw bedrijf, geen template.',
      'cases-live.mission.placeholder': 'Voeg je teamfoto toe in de Theme Editor',
      'cases-live.mission.title': 'Jouw succes is onze',
      'cases-live.mission.titleItalic': 'missie',
      'cases-live.proc.grid.cta': 'Plan een gesprek',
      'cases-live.proc.grid.eyebrow': 'Hoe wij werken',
      'cases-live.proc.grid.stat1.label': 'Omzet gegenereerd voor klanten',
      'cases-live.proc.grid.stat1.value': '€12M+',
      'cases-live.proc.grid.stat2.label': 'Maandelijks advertentiebudget beheerd',
      'cases-live.proc.grid.stat2.value': '€200k+',
      'cases-live.proc.grid.stat3.label': 'Merken opgeschaald',
      'cases-live.proc.grid.stat3.value': '40+',
      'cases-live.proc.grid.stat4.label': 'Gemiddelde return op advertentiebudget',
      'cases-live.proc.grid.stat4.value': '6X',
      'cases-live.proc.grid.step1.body': 'Alles wat wij bouwen is gericht op meetbare resultaten die jouw bedrijf vooruithelpen, van de eerste strategie tot de laatste uitvoering.',
      'cases-live.proc.grid.step1.number': '01',
      'cases-live.proc.grid.step1.title': 'Gericht op resultaat',
      'cases-live.proc.grid.step2.body': 'Open, transparante updates bij elke stap. Je bent altijd op de hoogte en geen detail glipt ertussendoor.',
      'cases-live.proc.grid.step2.number': '02',
      'cases-live.proc.grid.step2.title': 'Heldere, vaste communicatie',
      'cases-live.proc.grid.step3.body': 'Wij behandelen jouw bedrijf als ons eigen bedrijf en stemmen elke keuze af op jouw doelen, nooit een standaard draaiboek.',
      'cases-live.proc.grid.step3.number': '03',
      'cases-live.proc.grid.step3.title': 'Een strategie rond jou gebouwd',
      'cases-live.proc.grid.step4.body': 'Creatie, betaalde advertenties, CRM, software en AI werken als één machine, zodat elk kanaal dezelfde kant op trekt.',
      'cases-live.proc.grid.step4.number': '04',
      'cases-live.proc.grid.step4.title': 'Eén verbonden systeem',
      'cases-live.proc.grid.subtitle': 'Vier uitgangspunten die elk systeem op één ding gericht houden: échte klanten, geen ijdele cijfers.',
      'cases-live.proc.grid.title': 'Het Proces',
      'cases-live.proc.grid.titleItalic': '',

      /* AI Automations — sc-automations section */
      'ai.aut.urgency': 'Wat wij bouwen',
      'ai.aut.titleBefore': 'AI-automatiseringen op maat,',
      'ai.aut.titleItalic': 'gebouwd rond jouw bedrijf.',
      'ai.aut.subtitle': 'Zapier en Make zijn prima voor simpele A-naar-B taken. Maar de echte sprong komt van automatiseringen die zelf beslissen, koppelen met systemen waar templates niet bij komen, en zich aanpassen aan hoe jouw bedrijf echt werkt. Dat bouwen wij. Jouw team blijft de baas. AI doet het werk dat zich herhaalt.',
      'ai.aut.examplesLabel': '// Automatiseringen die wij hebben gebouwd',
      'ai.aut.cta': 'Klaar om te zien wat wij in jouw bedrijf kunnen automatiseren?',
      'ai.aut.ctaBtn': 'Plan een gratis audit',
      /* Flow steps inside sc-automations (4 blocks) */
      'ai.aut.b1.title': 'Input',
      'ai.aut.b1.desc': 'E-mail, formulier, lead, bestelling, gebeurtenis.',
      'ai.aut.b2.title': 'AI verwerkt',
      'ai.aut.b2.desc': 'Sorteren, verrijken, opstellen, beslissen.',
      'ai.aut.b3.title': 'Mens checkt',
      'ai.aut.b3.desc': 'Jouw team beoordeelt en keurt goed.',
      'ai.aut.b4.title': 'Output',
      'ai.aut.b4.desc': 'Verstuurd, gepost, opgeslagen, klaar.',
      /* AI Automations example cards — added 2026-05-02 to fix key collision with flow steps */
      'ai.aut.ex1.industry': 'Klantenwerving',
      'ai.aut.ex1.title': 'AI-chatbot die echt converteert',
      'ai.aut.ex1.desc': 'Op maat gemaakte chatbot die leads kwalificeert, afspraken inplant, FAQ\u2019s beantwoordt en opvolgt. Via WhatsApp of webchat. Voelt 100% menselijk aan, schaalt zonder limiet en vervangt het handmatige heen-en-weer zonder de persoonlijke touch te verliezen die converteert.',
      'ai.aut.ex1.m1Label': 'Bereikbaar',
      'ai.aut.ex1.m2Label': 'Kwalificatie',
      'ai.aut.ex2.industry': 'E-commerce',
      'ai.aut.ex2.title': 'AI-klantenservice op autopilot',
      'ai.aut.ex2.desc': 'Elke binnenkomende e-mail wordt op intentie geclassificeerd, krijgt een passend antwoord in jouw merkstem en wordt klaargezet voor goedkeuring. Daarna verstuurd binnen minuten.',
      'ai.aut.ex2.m1Label': 'Bespaard / week',
      'ai.aut.ex2.m2Label': 'Reactietijd',
      'ai.aut.ex3.industry': 'B2B-diensten',
      'ai.aut.ex3.title': 'Lead-kwalificatie en CRM-verrijking',
      'ai.aut.ex3.desc': 'Nieuwe leads krijgen een score, worden verrijkt met LinkedIn- en bedrijfsdata, gaan naar de juiste salesrep en worden automatisch opgevolgd tot er antwoord komt.',
      'ai.aut.ex3.m1Label': 'Gekwalificeerde leads',
      'ai.aut.ex3.m2Label': 'Handmatige invoer',
      'ai.aut.ex4.industry': 'Content',
      'ai.aut.ex4.title': 'Content op de automatische piloot',
      'ai.aut.ex4.desc': 'Eén lange video wordt 8 korte clips, 5 statische posts, 3 e-mails en een blog. Volledig in jouw merk, klaar voor review, gepland over alle kanalen.',
      'ai.aut.ex4.m1Label': 'Assets / dag',
      'ai.aut.ex4.m2Label': 'Toezicht',
      'ai.aut.ex5.industry': 'Operations',
      'ai.aut.ex5.title': 'Facturen en documenten op autopilot',
      'ai.aut.ex5.desc': 'Binnenkomende facturen, contracten en bonnen worden uitgelezen, gecategoriseerd en doorgezet naar jouw boekhoudsoftware. Uitzonderingen worden gemarkeerd voor controle.',
      'ai.aut.ex5.m1Label': 'Automatisch verwerkt',
      'ai.aut.ex5.m2Label': 'Bespaard / week',
      'ai.aut.ex6.industry': 'Sales',
      'ai.aut.ex6.title': 'Offertes genereren in minuten',
      'ai.aut.ex6.desc': 'Op basis van het transcript van een verkennend gesprek wordt een offerte op maat opgesteld, gebrand en klaargezet. Sales reviewt en verstuurt. Klaar in minuten in plaats van uren.',
      'ai.aut.ex6.m1Label': 'Per offerte',
      'ai.aut.ex6.m2Label': 'Volume',
      'ai.aut.ex7.industry': 'Marketing',
      'ai.aut.ex7.title': 'Ads die zichzelf bewaken',
      'ai.aut.ex7.desc': 'AI bewaakt jouw ad-accounts 24/7. Markeert fatigue, brengt winnaars naar boven, stelt scaling-acties op en geeft je team een alert zodra er iets aandacht nodig heeft.',
      'ai.aut.ex7.m1Label': 'Monitoring',
      'ai.aut.ex7.m2Label': 'ROAS',
      'ai.aut.ex8.industry': 'HR',
      'ai.aut.ex8.title': 'Sollicitaties die zichzelf screenen',
      'ai.aut.ex8.desc': 'Elk cv wordt uitgelezen, gescreend op jouw criteria, gerangschikt en als korte samenvatting bij de hiring manager bezorgd. Red flags komen automatisch boven.',
      'ai.aut.ex8.m1Label': 'Snellere screening',
      'ai.aut.ex8.m2Label': 'Minder ruis',
      'ai.aut.ex9.industry': 'Customer success',
      'ai.aut.ex9.title': 'Onboarding die klanten doet activeren',
      'ai.aut.ex9.desc': 'Nieuwe klanten krijgen gepersonaliseerde onboarding-momenten, getriggerd door productgebruik. AI stelt de e-mails op, jouw team controleert ze voor verzending.',
      'ai.aut.ex9.m1Label': 'Hogere activatie',
      'ai.aut.ex9.m2Label': 'Bespaard per dag',
      'ai.aut.ex10.industry': 'Finance',
      'ai.aut.ex10.title': 'Wekelijks rapport, automatisch',
      'ai.aut.ex10.desc': 'Data uit elke tool in jouw stack wordt omgezet in een gebrand weekrapport. AI schrijft de inzichten, jouw team keurt goed en verstuurt.',
      'ai.aut.ex10.m1Label': 'Automatisch gegenereerd',
      'ai.aut.ex10.m2Label': 'Bespaard / week',
      'ai.aut.ex11.industry': 'Recruitment',
      'ai.aut.ex11.title': 'Recruitment op AI-snelheid',
      'ai.aut.ex11.desc': 'AI bepaalt de vereisten voor een rol, scant daarna LinkedIn, social media en het web op passende kandidaten. Elk profiel krijgt een score, wordt gerangschikt en automatisch benaderd via e-mail, LinkedIn of WhatsApp op maat. Jouw team ziet alleen gekwalificeerde matches.',
      'ai.aut.ex11.m1Label': 'Profielen gescand / rol',
      'ai.aut.ex11.m2Label': 'Geautomatiseerd',

    }
  };

  function getInitialLang() {
    try {
      var saved = localStorage.getItem('sc_lang');
      if (saved === 'nl' || saved === 'en') return saved;
    } catch(e) {}
    var nav = ((navigator.language || navigator.userLanguage || 'en') + '').toLowerCase();
    return nav.indexOf('nl') === 0 ? 'nl' : 'en';
  }

  /* EN page → NL counterpart. Used for href-swap in NL mode + NL-page detection at init. */
  var NL_PAGES = {
    '/pages/terms': '/pages/algemene-voorwaarden',
    '/pages/privacy-policy': '/pages/privacybeleid',
    '/pages/cookie-policy': '/pages/cookiebeleid',
    '/pages/how-we-work': '/pages/hoe-wij-werken',
    '/pages/client-agreement': '/pages/klantovereenkomst'
  };
  /* Dutch-only pages: chrome (header/footer) renders in NL here while the rest of the site stays forced EN. */
  var NL_PATHS = [
    '/pages/groeisysteem', '/pages/ai-voor-klinieken', '/pages/keukens-en-badkamers',
    '/pages/algemene-voorwaarden', '/pages/privacybeleid', '/pages/cookiebeleid',
    '/pages/hoe-wij-werken', '/pages/klantovereenkomst'
  ];

  function applyLang(lang, persist) {
    if (lang !== 'nl' && lang !== 'en') lang = 'en';
    document.documentElement.setAttribute('data-lang', lang);
    document.documentElement.setAttribute('lang', lang);

    document.querySelectorAll('a[href]').forEach(function(a){
      var def = a.getAttribute('data-i18n-href-default');
      if (def === null) {
        def = a.getAttribute('href');
        if (!NL_PAGES[def]) return;
        a.setAttribute('data-i18n-href-default', def);
      }
      a.setAttribute('href', lang === 'nl' && NL_PAGES[def] ? NL_PAGES[def] : def);
    });

    document.querySelectorAll('[data-i18n-key]').forEach(function(el){
      var key = el.getAttribute('data-i18n-key');
      var isInput = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA';
      var hasHtmlOriginal = !isInput && el.children && el.children.length > 0;
      var stored = el.getAttribute('data-i18n-default');
      if (stored === null) {
        if (isInput) stored = el.getAttribute('placeholder') || '';
        else stored = hasHtmlOriginal ? el.innerHTML : el.textContent;
        el.setAttribute('data-i18n-default', stored);
        if (hasHtmlOriginal) el.setAttribute('data-i18n-html', '1');
      }
      var target = stored;
      if (lang !== 'en') {
        var val = STR[lang] && STR[lang][key];
        if (val !== undefined && val !== null) target = val;
      }
      if (isInput) {
        el.setAttribute('placeholder', target);
      } else if (el.hasAttribute('data-i18n-html') || /<[a-z][^>]*>/i.test(target)) {
        el.innerHTML = target;
      } else {
        el.textContent = target;
      }
    });

    var termMap = {
      'pipeline roas': 'pipeline ROAS',
      'quote value': 'offertewaarde',
      'first-intake pipeline value': 'eerste intake pipelinewaarde',
      'ad spend': 'advertentiebudget',
      'patient value generated': 'gegenereerde patiëntwaarde',
      'cost per lead': 'kosten per lead',
      'intake opportunities': 'intakekansen',
      'booked or handled intakes': 'geboekte of opgevolgde intakes',
      'leads': 'leads',
      'quote matches': 'offerte matches',
      'roas': 'ROAS',
      '€35,200 pipeline value from €2,877.78 ad spend': '€35.200 pipelinewaarde uit €2.877,78 advertentiebudget',
      'attributed revenue in 3 months': 'toegerekende omzet in 3 maanden',
      'built from zero — we laid the entire marketing foundation. ~€1.4m generated in 10 months.': 'Vanaf nul opgebouwd — wij legden het complete marketingfundament. ~€1,4M gegenereerd in 10 maanden.',
      'meta form leads': 'Meta-formulierleads',
      'meta leads': 'Meta-leads',
      'return on ad spend': 'Rendement op advertentiebudget',
      'add-to-carts': 'toevoegingen aan winkelwagen',
      'attributed revenue': 'toegerekende omzet',
      'conversion rate': 'conversieratio',
      'cost per click': 'kosten per klik',
      'estimated patient value': 'geschatte patiëntwaarde',
      'generated in 10 months': 'gegenereerd in 10 maanden',
      'inbound captured': 'inbound opgevangen',
      'we built the foundation': 'wij bouwden het fundament',
    };
    document.querySelectorAll('[data-i18n-term]').forEach(function(el){
      var original = el.getAttribute('data-i18n-term-default');
      if (original === null) {
        original = el.textContent || '';
        el.setAttribute('data-i18n-term-default', original);
      }
      var normalized = (original || '').trim().toLowerCase();
      el.textContent = lang === 'nl' && termMap[normalized] ? termMap[normalized] : original;
    });

    document.querySelectorAll('[data-lang-opt]').forEach(function(opt){
      var match = opt.getAttribute('data-lang-opt') === lang;
      opt.classList.toggle('active', match);
      opt.setAttribute('aria-pressed', match ? 'true' : 'false');
    });

    if (persist !== false) { try { localStorage.setItem('sc_lang', lang); } catch(e) {} }

    document.dispatchEvent(new CustomEvent('sc:langchange', { detail: { lang: lang } }));
  }

  window.scSetLang = applyLang;
  window.scGetLang = function(){ return document.documentElement.getAttribute('data-lang') || 'en'; };

  function init() {
    var path = location.pathname.replace(/\/+$/, '');
    var isNLPage = NL_PATHS.indexOf(path) !== -1;
    applyLang(isNLPage ? 'nl' : 'en', false); /* site forced EN, Dutch pages get NL chrome — toggle hidden; restore getInitialLang() to re-enable NL */
    document.querySelectorAll('[data-lang-opt]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        applyLang(this.getAttribute('data-lang-opt'));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ===== Smart anchor links =====
     Links rendered as "/#anchor" should scroll to a local element with that id
     IF that id exists on the current page, instead of bouncing to homepage. */
  document.addEventListener('click', function(e) {
    var link = e.target.closest && e.target.closest('a[href^="/#"]');
    if (!link) return;
    var hash = link.getAttribute('href').substring(1); /* "#industries" */
    if (!hash || hash.length < 2) return;
    var target = document.querySelector(hash);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try { history.replaceState(null, '', hash); } catch(err) {}
    }
  });
})();
